import './lib/closest-polyfill';
import './components/breakUrls.js';
import './components/fileUpload.js';
import './components/cookieConsent.js';

// import class components
import FixedDownload from './components/FixedDownload';
import ScrollTo from './components/ScrollTo';

// initialize components
window.fixedDowload = new FixedDownload();
window.scrollToIntro = new ScrollTo();

const urlParams = new URLSearchParams(window.location.search);
const exchangezone = urlParams.get('exchangezone');

if (exchangezone !== null) {
  window.location = "https://info.eworld1700.be/how-to-use-exchange-zone-qr-codes-on-route-1700";
}
